import api from "./apiService";
import { API_PASSWORD } from "./apiConfig";

/**
 * جلب معاملات (ترانزاكشن) الموزع حسب المعرف
 * @param {string|number} brokerId - معرف الموزع
 * @param {Object} params - معلمات استعلام إضافية (page, from, to, ...)
 * @param {string} token - توكن المصادقة (اختياري)
 * @returns {Promise} Axios Promise
 */
export const getBrokerTransactions = (brokerId, params = {}, token) => {
  if (!brokerId) throw new Error("brokerId is required");

  const storedToken =
    token ||
    localStorage.getItem("token") ||
    localStorage.getItem("accessToken") ||
    localStorage.getItem("authToken") ||
    null;

  const queryObj = { ...params, api_password: API_PASSWORD };
  const query = new URLSearchParams(queryObj).toString();

  const headers = {
    ...(storedToken ? { Authorization: `Bearer ${storedToken}` } : {}),
  };

  return api.get(`get/broker/transaction/${brokerId}?${query}`, { headers });
};

// أضفنا دالة لحفظ/إنشاء معاملة للموزع (form-data)
export const saveBrokerTransaction = async (data = {}, token) => {
  const storedToken =
    token ||
    localStorage.getItem("token") ||
    localStorage.getItem("accessToken") ||
    localStorage.getItem("authToken") ||
    null;

  const query = new URLSearchParams({ api_password: API_PASSWORD }).toString();

  const formData = new FormData();
  Object.keys(data).forEach((key) => {
    const value = data[key];
    if (value === undefined || value === null) return;
    if (Array.isArray(value)) {
      value.forEach((v) => formData.append(`${key}[]`, v));
    } else {
      formData.append(key, value);
    }
  });

  const headers = {
    ...(storedToken ? { Authorization: `Bearer ${storedToken}` } : {}),
    Accept: "application/json",
    // لا نحدد Content-Type ليقوم المتصفح بضبط boundary عند إرسال FormData
  };

  return api.post(`save/broker/transaction?${query}`, formData, { headers });
};

// أضفنا دالة لتعديل معاملة الموزع (form-data) عبر edite/broker/transaction/{id}
export const editBrokerTransaction = async (id, data = {}, token) => {
  if (!id) throw new Error("transaction id is required");

  const storedToken =
    token ||
    localStorage.getItem("token") ||
    localStorage.getItem("accessToken") ||
    localStorage.getItem("authToken") ||
    null;

  const query = new URLSearchParams({ api_password: API_PASSWORD }).toString();

  const formData = new FormData();
  Object.keys(data).forEach((key) => {
    const value = data[key];
    if (value === undefined || value === null) return;
    if (Array.isArray(value)) {
      value.forEach((v) => formData.append(`${key}[]`, v));
    } else {
      formData.append(key, value);
    }
  });

  const headers = {
    ...(storedToken ? { Authorization: `Bearer ${storedToken}` } : {}),
    Accept: "application/json",
  };

  return api.post(`edite/broker/transaction/${id}?${query}`, formData, { headers });
};

// أضفنا دالة لحذف معاملة الموزع (المسار يستخدم GET كما في مثال الـ API)
export const deleteBrokerTransaction = async (id, token) => {
  if (!id) throw new Error("transaction id is required for delete");

  const storedToken =
    token ||
    localStorage.getItem("token") ||
    localStorage.getItem("accessToken") ||
    localStorage.getItem("authToken") ||
    null;

  const query = new URLSearchParams({ api_password: API_PASSWORD }).toString();

  const headers = {
    ...(storedToken ? { Authorization: `Bearer ${storedToken}` } : {}),
    Accept: "application/json",
  };

  // API example uses GET for delete endpoint
  return api.get(`delete/broker/transaction/${id}?${query}`, { headers });
};

/**
 * جلب إصدارات الموزع (broker versions) حسب معرف الموزع
 * @param {string|number} brokerId
 * @param {Object} params - معلمات استعلام إضافية
 * @param {string} token - توكن المصادقة (اختياري)
 * @returns {Promise} Axios Promise
 */
export const getBrokerVersions = (user_id, params = {}, token) => {
  if (!user_id) throw new Error("user_id is required");

  const storedToken =
    token ||
    localStorage.getItem("token") ||
    localStorage.getItem("accessToken") ||
    localStorage.getItem("authToken") ||
    null;

  const queryObj = { ...params, api_password: API_PASSWORD };
  const query = new URLSearchParams(queryObj).toString();

  const headers = {
    ...(storedToken ? { Authorization: `Bearer ${storedToken}` } : {}),
  };

  return api.get(`get/broker/versions/${user_id}?${query}`, { headers });
};

export default {
  getBrokerTransactions,
  getBrokerVersions,
  saveBrokerTransaction,
  editBrokerTransaction,
  deleteBrokerTransaction,
};


